module.exports = function(PluginManager) {
  // Register API.
  PluginManager.registerApiModule('behavior', require('./api'));
};
